<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header d-flex justify-content-between">
        <div>
          <h3 class="page-title">
            {{ $t('settings.currencies.title') }}
          </h3>
        </div>
      </div>

      <table-component
        :show-filter="false"
        :data="currencies"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :sortable="true"
          :label="$t('settings.currencies.name')"
          show="name"
        />
        <table-column
          :sortable="true"
          :label="$t('settings.currencies.code')"
          show="code"
        />
        <table-column
          :sortable="true"
          :label="$t('settings.currencies.symbol')"
          show="symbol"
        />
        <table-column
          :sortable="true"
          :label="$t('settings.currencies.precision')"
          show="precision"
        />
        
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span>{{ $t('settings.tax_types.action') }}</span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <div class="dropdown-item" @click="EditCurrency(row.id)">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                  {{ $t('general.edit') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      id: null,
      formData: {
        tax_per_item: false
      }
    }
  },
  computed: {
    ...mapGetters('currency', [
      'currencies',
    ])
  },
  mounted () {},
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('currency', [
      'editCurrency'
    ]),
    
    async EditCurrency (id) {
        let response = await this.editCurrency(id)
        this.openModal({
            'title': 'Edit Currency',
            'componentName': 'CurrencyModal',
            'id': id,
            'data': response.data.currency
        })
    }
  }
}
</script>
